/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.6.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ReadingFromJSON, ReadingToJSON, } from './';
export function MeterFromJSON(json) {
    return MeterFromJSONTyped(json, false);
}
export function MeterFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'meterID': !exists(json, 'meterID') ? undefined : json['meterID'],
        'assetID': !exists(json, 'assetID') ? undefined : json['assetID'],
        'meterWKTaskCreationID': !exists(json, 'meterWKTaskCreationID') ? undefined : json['meterWKTaskCreationID'],
        'meterName': !exists(json, 'meterName') ? undefined : json['meterName'],
        'meterType': !exists(json, 'meterType') ? undefined : json['meterType'],
        'meterUnits': !exists(json, 'meterUnits') ? undefined : json['meterUnits'],
        'intervalTarget': !exists(json, 'intervalTarget') ? undefined : json['intervalTarget'],
        'intervalAverage': !exists(json, 'intervalAverage') ? undefined : json['intervalAverage'],
        'maxReading': !exists(json, 'maxReading') ? undefined : json['maxReading'],
        'minReading': !exists(json, 'minReading') ? undefined : json['minReading'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'cMeterNameUnitsDisplay': !exists(json, 'cMeterNameUnitsDisplay') ? undefined : json['cMeterNameUnitsDisplay'],
        'readings': !exists(json, 'readings') ? undefined : (json['readings'] === null ? null : json['readings'].map(ReadingFromJSON)),
    };
}
export function MeterToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'meterID': value.meterID,
        'assetID': value.assetID,
        'meterWKTaskCreationID': value.meterWKTaskCreationID,
        'meterName': value.meterName,
        'meterType': value.meterType,
        'meterUnits': value.meterUnits,
        'intervalTarget': value.intervalTarget,
        'intervalAverage': value.intervalAverage,
        'maxReading': value.maxReading,
        'minReading': value.minReading,
        'notes': value.notes,
        'cMeterNameUnitsDisplay': value.cMeterNameUnitsDisplay,
        'readings': value.readings === undefined ? undefined : (value.readings === null ? null : value.readings.map(ReadingToJSON)),
    };
}
